import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      maxWidth: '700px',
    },
  },
  dialogContent: {
    gap: spacing(30),
    padding: spacing(40),
    minHeight: spacing(50),
  },
  formContainer: {
    marginTop: spacing(50),
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: spacing(30),
    marginTop: spacing(20),
  },
  selectWrapper: {
    flex: 1,
    margin: 0,
    height: '100% !important',
    '& .MuiFormLabel-root': {
      fontSize: `${spacing(18)} !important`,
    },
  },
  categoriesWrapper: {
    flex: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing(10),
  },
  iconButton: {
    maxWidth: 'fit-content',
    height: 'fit-content',
    marginTop: '20px',
    '@media(max-width: 600px)': {
      marginTop: 0,
    },
  },
  editIcon: {
    width: '20.14px',
    height: '19.57px',
  },
  textArea: {
    width: '100%',
  },
  textAreaContainer: {
    flex: 1,
    width: '100%',
  },
  textAreaLabel: {
    display: 'flex',
    color: `${Theme.Colors.Grayscale.OneThousand} !important`,
    fontSize: spacing(12),
    marginBottom: spacing(8),
    whiteSpace: 'nowrap',
  },
  asterisk: {
    color: Theme.Colors.Red.Base,
    marginLeft: '4px',
  },
  thinErrorUnderline: {
    '&.MuiInputBase-root.Mui-error:after': {
      borderBottom: `1px solid ${palette.error.main} !important`,
      borderBottomWidth: '1px !important',
    },
    '&.MuiInputBase-root:after': {
      borderBottomWidth: '1px !important',
    },
  },
}))
